var React = require('react');

function ArrowMore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.69,1.7A1.07,1.07,0,0,1,6.43,1,1.06,1.06,0,0,1,6.7.29.89.89,0,0,1,7.34,0,.88.88,0,0,1,8,.28l2.75,3A1.08,1.08,0,0,1,11,4a1.06,1.06,0,0,1-.27.71L8,7.7a.83.83,0,0,1-1,.23.84.84,0,0,1-.31-.22,1.16,1.16,0,0,1-.2-.32A1.06,1.06,0,0,1,6.41,7a1,1,0,0,1,.07-.39,1,1,0,0,1,.21-.32L7.87,5H.92A.86.86,0,0,1,.27,4.7,1.06,1.06,0,0,1,0,4a1.08,1.08,0,0,1,.27-.71A.89.89,0,0,1,.92,3h7Z"}));
}

ArrowMore.defaultProps = {"width":"11","height":"8","viewBox":"0 0 11 8.01"};

module.exports = ArrowMore;

ArrowMore.default = ArrowMore;
